import type { CommunityDiscoveryCounts, CommunityFollower } from "@/types/api";
import type { CommunityProfile } from "@/types/community";
import { request } from "./transport";

export const communityProfiles = {
  discovery: () =>
    request<{ counts: CommunityDiscoveryCounts }>(
      "/community_profiles/discovery",
    ),
  followers: (cursor?: number) =>
    request<{ followers: CommunityFollower[]; next_cursor: number | null }>(
      `/community_profiles/followers${cursor ? `?cursor=${cursor}` : ""}`,
    ),
  getCommunityProfile: (id: number) =>
    request<{ profile: CommunityProfile }>(`/community_profiles/${id}`),

  followCommunityProfile: (id: number) =>
    request<{ profile: CommunityProfile }>(`/community_profiles/${id}/follow`, {
      method: "POST",
    }),

  unfollowCommunityProfile: (id: number) =>
    request<{ profile: CommunityProfile }>(
      `/community_profiles/${id}/unfollow`,
      { method: "DELETE" },
    ),
};
